/** Escala de navegação: multiplica alvos de toque sem mexer no tamanho do
 *  texto, que já é do Dynamic Type. Some-se às duas coisas e o desenho
 *  atende quem precisa de botão grande com texto grande. */
const CHAVE = 'sheafyield:escala';
const VALORES = [100, 125, 150, 175] as const;
export type Escala = (typeof VALORES)[number];

/** Exportado porque a tela de Ajustes converte na fronteira: o
 *  `GrupoDeChips` fala em `string` (é o `value` de um rádio) e a escala é
 *  número. Só reconhece número: uma string nunca é uma `Escala`, e fingir
 *  que é obrigaria a um `as` em quem lê. */
export function ehEscala(v: unknown): v is Escala {
  return VALORES.some((x) => x === v);
}

/** Converte o que veio de fora (armazenamento, `value` de rádio) e devolve
 *  `null` se não for uma escala conhecida. */
export function paraEscala(v: unknown): Escala | null {
  const n = Number(v);
  return ehEscala(n) ? n : null;
}

export function lerEscala(): Escala {
  try {
    const guardada = paraEscala(localStorage.getItem(CHAVE));
    if (guardada !== null) return guardada;
  } catch {
    // Armazenamento negado (janela privada): a escala padrão serve.
  }
  return 100;
}

export function gravarEscala(e: Escala): void {
  try {
    // 100 % é a ausência de escolha: guardar o padrão só criaria lixo que
    // sobreviveria a uma mudança futura do padrão.
    if (e === 100) localStorage.removeItem(CHAVE);
    else localStorage.setItem(CHAVE, String(e));
  } catch {
    // Não poder lembrar não impede aplicar agora.
  }
  if (e === 100) delete document.documentElement.dataset['escala'];
  else document.documentElement.dataset['escala'] = String(e);
}

/** Aplica antes da primeira pintura; chamada do `index.html` não serve porque
 *  o módulo ainda não carregou — quem chama é a partida em `main.tsx`. */
export function aplicarEscalaGravada(): void {
  gravarEscala(lerEscala());
}
